import React, {useEffect, useRef, useState} from "react";
import {paper} from "paper/dist/paper-full.min";
import {getStroke} from "perfect-freehand";
import {createConnection} from "../../services/fetch";


const Test = ({linesv}) => {
    console.log(linesv);

    const getSvgPathFromStroke = (stroke) => {
        if (!stroke.length) {
            return '';
        }

        const d = stroke.reduce(
            (acc, [x0, y0], i, arr) => {
                const [x1, y1] = arr[(i + 1) % arr.length];
                acc.push(x0, y0, (x0 + x1) / 2, (y0 + y1) / 2);
                return acc;
            },
            ['M', ...stroke[0], 'Q']
        );

        d.push('Z');
        return d.join(' ');
    }
  //  const =require('../../static/snapshots/extracted_lines.json')
const canv=useRef();
    const project=useRef(null);

    const [cols,setCols]=useState(false);
    const  createRandomString = (length)=>{
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }
const upl=(t)=>{
const bo = (project.current.activeLayer.children[0].bounds)
    console.log(cols);
let tot=0;


const arr = cols.map((f, i) => {

                    const pa = new paper.Path(f.vertices.map((a) => new paper.Segment(new paper.Point(a.x, a.y))));
                     tot += pa.length + 40;

    return {
        start: i,
        line: '[]',
        dots: f.vertices.map((a) =>{ return {po: JSON.stringify([a.x.toFixed(3), a.y.toFixed(3), a.pressure]).replace(/"/g,'')}}),
        objet: 'sid',
        color: f.color,
        delta: Math.ceil(pa.length),
        type: f.brush_type,
        width: f.width,


    }
});

    const ar1 = arr.map(m => {
        return {po: m.dots}
    });
    const ar2 = arr.map(m => {
        m.totalpoints = m.dots.length;
        delete m.dots;
        return m
    });


    createConnection().insert('sujet', {
        user: 11,
        name: createRandomString(6),
        story: 90,
        totaltime: Math.floor(tot),
       size: Math.floor(bo.width).toString().concat(',',Math.floor(bo.height).toString(), ',', Math.floor(bo.x).toString(), ',', Math.floor(bo.y).toString())
    }, 2).then(c => {

        createConnection().insert('objet', {sujet: c, start: 0, delta: 0, deltaR: 0}, 2).then(cc => {
            let r = [];
            console.log('delete from strokes where objet='+cc+';delete from objet  where id='+cc+';delete from sujet  where id='+c+';')
 createConnection().getnue({parent:cc,target:'strokes',data:ar2}, 'POST').then(
                dd => {
                    dd.con.map((ddd, ig) => {
                        if(ar1[ig]){

                            const f = ar1[ig]

                            if(f.po instanceof Array) {

                                f.po.map(y => y.strokes = ddd)
                                r = r.concat(f.po)
                            }
                        }
                    })


                    createConnection().getnue({target:'point',data:r}, 'POST').then(ff=>{



                    })

                })


        });
    })


}


    useEffect(()=>{



       if(!cols) {

const linesvMy = linesv ? linesv : require('../../static/snapshots/extracted_lines.json');
           console.log(linesvMy)
           const w = 1028
          const h = 1600
                    canv.current.style.width = Math.round(w/1.6) + 'px';

                    canv.current.style.height =  Math.round(h/1.6) + 'px';
                    paper.setup(canv.current);
                    canv.current.width = w;
           canv.current.height = h;
                   const gr = new paper.Group({});
                   gr.applyMatrix = false;

                   paper.project.activeLayer.addChild(gr);


const arr=[]

                  linesvMy.lines.map((line,index)=>{
//console.log(line)
                      const limits= line.brush_type=='Pen'  ? [1,5] : line.brush_type=='Feltpen'  ? [5,40] : [30,180] ;

                      line.brush_type=='Highlighter' && console.log(line.base_brush_width)
                     // console.log(line.vertices)
                      const aa=line.vertices.map(a => {return {
                           x:-a.x, y:2000+a.y,pressure:1,v: a.v,w: a.w }})
                      const width = limits[0] + (Math.pow(line.base_brush_width, 3) * (limits[1]  - limits[0] ))
line.width=width;
                      const svgL=new paper.Path({segments:aa.map(a=>new paper.Segment(new paper.Point(a.x,a.y)))});
                      svgL.smooth({type: 'continuous'})
                      line.brush_type=='Highlighter' && svgL.simplify(4)
                      svgL.closed=false;
                      const lan = svgL.exportSVG({asString: true}).match(/\bd="([^"]+)"/)[1];
                      line.svg=lan;
                      const d = getSvgPathFromStroke(getStroke(aa,
                            {
                                size: width*2, thinning: -.8,


                          streamline: 0.2,
                          easing: (t) => t*t*t,
                          start: {
                          taper: 60,
                              cap: true,
                      },
                          end: {
                              taper: 60,
                                  cap: true,
                          },

                                simulatePressure: true
                            }

                            ));

                        const ln = new paper.Path(d);



                        ln.data = {line:line};
                        if(line.opacity<1 && !arr.includes(line.brush_type_id+','+line.color))  arr.push(line.brush_type_id+','+line.color)

                        ln.opacity=line.opacity
                            ln.closed = false;

                        if(line.brush_type!='Pen'){
                            ln.segments = aa.map((a,i) => [a.x,a.y])
                            ln.strokeWidth=width;
                            ln.strokeCap = 'square';
                            ln.strokeColor=new paper.Color(line.color)
                            //ln.fullySelected=true;
                           ln.strokeJoin = 'bevel';
                          // console.log(line.vertices)

                        }else{

                          //  console.log(ln.pathData)

                            ln.style = {

                                fillColor: new paper.Color(line.color)

                            };

                        }
                        ln.onClick = function(event) {
                            console.log(event.target.data)
                        }
                        paper.project.activeLayer.children[0].addChild(ln);
/*
              const text = new paper.PointText(ln.segments[0].point);
                            text.justification = 'center';
                            text.fillColor = 'black';
                            text.content = ' size: '+line.base_brush_width+ ' '+width;
                 const text = new paper.PointText(ln.segments[0].point);
                        text.justification = 'center';
                        text.fillColor = 'black';
                        text.content = 'id: '+ line.brush_type_id+ ' size: '+line.base_brush_width;
                       // paper.project.activeLayer.children[0].addChild(text);

                   */
                       // ln1.fullySelected=true;
                    //console.log(line);

                      //  paper.project.activeLayer.addChild(ln1);
line.vertices=aa
                      //
                    })

                    //console.log(paper.project.view.update());
                    //setTimeout(()=>paper.project.view.requestUpdate(),1000);


setCols(linesvMy.lines)
project.current=paper.project;
                }


    },[])



    // Use useRef for mutable variables that we want to persist
    // without triggering a re-render on their change
    //const requestRef = useRef();      <path opacity={.5}  strokeLinecap="square" stroke={f.color} key={i} strokeWidth={f.width}  d={f.svg} fill="none"/>
    //
    return <div className="bg-white">
        <canvas  ref={canv}/>
        <div >


    </div>
        {cols && (
            <svg width={900} height={1600}>
                {cols.map((f, i) => (
<>
    {f.vertices.length==1 ? (
            <rect opacity={.2} stroke='none' fill={f.color} width={f.width} height={f.width} x={f.vertices[0].x}  y={f.vertices[0].y}/>

   ): (

        <path opacity={f.brush_type == 'Pen' ? 1:.2}  strokeLinecap="square" stroke={f.color} key={i} strokeWidth={f.width}  d={f.svg} fill="none"/>
    )

    }

</>

                ))}
            </svg>
        )}
        {cols && (
            <button className={"fixed top-0"} onClick={()=>upl(true)}>loaddd</button>
        )
        }
    </div>
    // Make sure the effect runs only once
}
export default Test;